import { useParams } from '@tanstack/react-router'
import { SopReader } from '@/shell/services/sop-registry'

/** /sop-manage/$sopId — one SOP as a full page, with authoring actions. */
export function SopManageReaderPage() {
  const { sopId } = useParams({ strict: false }) as { sopId?: string }
  if (!sopId) return null
  return (
    <SopReader
      key={sopId}
      sopId={sopId}
      backTo="/sop-manage"
      backLabel="SOP Management"
      canAct
      editTo={`/sop-manage/${sopId}/edit`}
    />
  )
}
